import Filter from "../icons/Filter";

interface FilterToggleProps {
    active: boolean;
    onToggle: () => void;
    semester: string;
}

export default function FilterToggle({ active, onToggle, semester }: FilterToggleProps) {
    return (
        <button
            onClick={onToggle}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                active
                    ? "bg-indigo-100 text-indigo-700"
                    : "bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
            }`}
        >
            <Filter className="h-4 w-4" />
            <span>{semester} only</span>
        </button>
    );
}
